// Encodings that can be streamed
export const AudioEncoding = {
  LINEAR16: 'LINEAR16',
  OGG_OPUS: 'OGG_OPUS'
}
